import React from 'react';

const Icon = ({ size = '45', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 45 45" fill="none" {...other}>
            <g clipPath="url(#a)">
                <path
                    d="M8.344 7.45v6.953m0-5.563h6.954m-6.954 4.172h6.954m20.861 1.466V7.449m0 5.563h-6.954m6.954-4.172h-6.954m-9.23.383v5.255m4.553-5.255v5.255"
                    stroke="black"
                    strokeWidth="2.086"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                <path
                    clipRule="evenodd"
                    d="M20.86 29.702h2.782v-8.345h-2.781v8.345Z"
                    stroke="black"
                    strokeWidth="2.086"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                <path fillRule="evenodd" clipRule="evenodd" d="M20.86 38.045a1.39 1.39 0 0 0 2.782 0v-8.344h-2.781v8.344Z" fill="black" />

                <path
                    d="m32.756 29.465-3.942 3.942 1.575 1.574-3.484 3.485M11.807 29.16l3.942 3.941-1.575 1.575 3.485 3.485"
                    stroke="black"
                    strokeWidth="2.086"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                <path
                    d="M15.298 6.754c0-.384.311-.695.695-.695H28.51c.384 0 .695.31.695.695v9.2a.695.695 0 0 1-.695.695h-2.086a.696.696 0 0 0-.696.696v3.316a.695.695 0 0 1-.695.695H19.47a.695.695 0 0 1-.695-.695v-3.316a.695.695 0 0 0-.696-.696h-2.086a.695.695 0 0 1-.695-.695v-9.2Z"
                    stroke="black"
                    strokeWidth="2.086"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="white" d="M0 .496h44.503v44.503H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
